export default "__VITE_ASSET__486b2072__"